import React from 'react';
import { User } from 'lucide-react';
import WorkspaceSummary from '../../components/WorkspaceSummary';
import { useAuth } from '../../contexts/AuthContext';
import SettingsShell from './SettingsShell';
import SettingsNav from './SettingsNav';

const SettingsHome = () => {
  const { user } = useAuth();

  return (
    <SettingsShell
      title="Settings"
      description="Manage your account, workspace, and billing preferences."
    >
      <div className="rounded-xl border border-gray-200 bg-white p-5 text-gray-900">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 bg-primary-50 rounded-full flex items-center justify-center backdrop-blur-sm">
            <User className="w-7 h-7 text-primary-700" />
          </div>
          <div className="min-w-0">
            <h3 className="font-bold text-lg truncate">
              {user?.fullName || 'Your Account'}
            </h3>
            <p className="text-gray-600 text-sm truncate">
              {user?.email || 'Signed in'}
            </p>
          </div>
        </div>
      </div>

      <WorkspaceSummary showLink />
      <div className="lg:hidden">
        <SettingsNav variant="list" />
      </div>
    </SettingsShell>
  );
};

export default SettingsHome;
